var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMediumImg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 25,
    viewBox: "0 0 92 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.288863,
    y: 0.288863,
    width: 91.4223,
    height: 24.4223,
    rx: 5.48839,
    fill: "url(#paint0_radial_155_63)",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.288863,
    y: 0.288863,
    width: 91.4223,
    height: 24.4223,
    rx: 5.48839,
    stroke: "#17B9FF",
    strokeOpacity: 0.1,
    strokeWidth: 0.577726
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.288863,
    y: 0.288863,
    width: 91.4223,
    height: 24.4223,
    rx: 5.48839,
    stroke: "url(#paint1_linear_155_63)",
    strokeWidth: 0.577726,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4602 16.3809V6.17486H21.3082L24.5142 14.5469H24.5702L27.7902 6.17486H29.6242V16.3809H28.4482V11.2429L28.4902 7.44886H28.3922L25.0462 16.3809H24.0662L20.7062 7.44886H20.6082L20.6362 11.2429V16.3809H19.4602ZM34.9874 16.5069C34.2687 16.5069 33.6481 16.3529 33.1254 16.0449C32.6027 15.7275 32.1967 15.2842 31.9074 14.7149C31.6274 14.1455 31.4874 13.4829 31.4874 12.7269C31.4874 11.9615 31.6274 11.2942 31.9074 10.7249C32.1874 10.1555 32.5841 9.71219 33.0974 9.39486C33.6107 9.07753 34.2221 8.91886 34.9314 8.91886C35.7247 8.91886 36.3781 9.09619 36.8914 9.45086C37.4047 9.79619 37.7734 10.2722 37.9974 10.8789C38.2214 11.4762 38.2961 12.1529 38.2214 12.9089H32.6074C32.6261 13.7582 32.8501 14.4162 33.2794 14.8829C33.7087 15.3402 34.2781 15.5689 34.9874 15.5689C35.5381 15.5689 36.0047 15.4429 36.3874 15.1909C36.7701 14.9295 37.0081 14.5842 37.1014 14.1549H38.1934C38.1281 14.6215 37.9461 15.0322 37.6474 15.3869C37.3487 15.7415 36.9707 16.0169 36.5134 16.2129C36.0561 16.4089 35.5474 16.5069 34.9874 16.5069ZM34.9174 9.84286C34.2827 9.84286 33.7601 10.0389 33.3494 10.4309C32.9481 10.8135 32.7101 11.3455 32.6354 12.0269H37.1154C37.0967 11.2522 36.8774 10.6969 36.4574 10.3609C36.0374 10.0155 35.5241 9.84286 34.9174 9.84286ZM42.5095 16.5069C41.6041 16.5069 40.8715 16.1755 40.3115 15.5129C39.7608 14.8502 39.4855 13.9122 39.4855 12.6989C39.4855 11.4855 39.7608 10.5522 40.3115 9.89886C40.8715 9.23619 41.6041 8.90486 42.5095 8.90486C43.1535 8.90486 43.7041 9.05886 44.1615 9.36686C44.6188 9.66553 44.9361 10.0622 45.1135 10.5569H45.1835V6.17486H46.3175L46.3035 16.3809H45.2255L45.1835 14.8409H45.1135C44.9361 15.3355 44.6188 15.7369 44.1615 16.0449C43.7041 16.3529 43.1535 16.5069 42.5095 16.5069ZM42.8875 15.5549C43.3821 15.5549 43.7975 15.4429 44.1335 15.2189C44.4695 14.9855 44.7261 14.6869 44.9035 14.3229C45.0808 13.9495 45.1695 13.5575 45.1695 13.1469V12.2509C45.1695 11.8402 45.0808 11.4529 44.9035 11.0889C44.7261 10.7155 44.4695 10.4169 44.1335 10.1929C43.7975 9.95953 43.3821 9.84286 42.8875 9.84286C42.2155 9.84286 41.6741 10.0855 41.2635 10.5709C40.8528 11.0562 40.6475 11.7655 40.6475 12.6989C40.6475 13.6229 40.8528 14.3322 41.2635 14.8269C41.6741 15.3122 42.2155 15.5549 42.8875 15.5549ZM48.439 7.81286V6.17486H49.573V7.81286H48.439ZM48.439 16.3809V9.03086H49.573V16.3809H48.439ZM54.2966 16.5069C53.4752 16.5069 52.8266 16.2595 52.3506 15.7649C51.8746 15.2702 51.6366 14.5282 51.6366 13.5389V9.03086H52.7706V13.2589C52.7706 13.9869 52.9199 14.5515 53.2186 14.9529C53.5172 15.3449 54.0072 15.5409 54.6886 15.5409C55.3512 15.5409 55.8879 15.3029 56.2986 14.8269C56.7092 14.3415 56.9146 13.7162 56.9146 12.9509V9.03086H58.0486V16.3809H56.9706L56.9146 14.8129H56.8446C56.6579 15.3355 56.3312 15.7509 55.8646 16.0589C55.4072 16.3575 54.8846 16.5069 54.2966 16.5069ZM60.1011 16.3809V9.03086H61.1791L61.2211 10.5569H61.3051C61.5198 10.0155 61.8558 9.60953 62.3131 9.33886C62.7704 9.05886 63.2744 8.91886 63.8251 8.91886C64.3851 8.91886 64.8798 9.05419 65.3091 9.32486C65.7478 9.59553 66.0558 10.0482 66.2331 10.6829H66.3451C66.5598 10.1042 66.9051 9.66553 67.3811 9.36686C67.8664 9.06819 68.4078 8.91886 69.0051 8.91886C69.4998 8.91886 69.9384 9.02153 70.3211 9.22686C70.7131 9.43219 71.0211 9.76819 71.2451 10.2349C71.4691 10.6922 71.5811 11.2989 71.5811 12.0549V16.3809H70.4611V12.2789C70.4611 11.4482 70.3118 10.8415 70.0131 10.4589C69.7144 10.0669 69.2478 9.87086 68.6131 9.87086C68.1651 9.87086 67.7778 9.98286 67.4511 10.2069C67.1244 10.4309 66.8678 10.7342 66.6811 11.1169C66.5038 11.4902 66.4151 11.9195 66.4151 12.4049V16.3809H65.2671V12.2789C65.2671 11.4482 65.1178 10.8415 64.8191 10.4589C64.5298 10.0669 64.0724 9.87086 63.4471 9.87086C62.9991 9.87086 62.6071 9.98286 62.2711 10.2069C61.9351 10.4309 61.6738 10.7342 61.4871 11.1169C61.3098 11.4902 61.2211 11.9195 61.2211 12.4049V16.3809H60.1011Z",
    fill: "#F1B503"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_155_63",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1719 1.07422) rotate(42.715) scale(40.597 47.4035)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DACD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.780575,
    stopColor: "#1C1B33",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_155_63",
    x1: 4.22703,
    y1: 2.46771e-7,
    x2: 7.74283,
    y2: 20.5194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMediumImg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/medium-img.d7cc5dbd580873fdcccdf7e4c6f70e85.svg";